// utils/tableColumnNamesScoring.js
export const tableColumnNamesScoring = {
  Name: 'memberName',
  Role: 'memberRole',
  Committee: 'committeeName',
  'Election Type': 'electionType',
  'Bias Training': 'biasTrainingStatus',
  'Scored Candidates': 'scoringProgress',
  Progress: 'completionPercentage',

  'Created at': 'createdAt',
  'Updated at': 'updatedAt',
  'Published at': 'publishedAt',
};
